import { useEffect, useState } from "react"
import { InputModel } from "../../../../../../../../../utils/types"
import { useFilter } from "../../../../../../../../../hooks/filter"
import { Item } from "../../../../../../../../../utils/types/generals"
import { FilterProps } from "../../../../../../../../../hooks/filter/typing"
import { removeAllReference } from "../../../../../../../../../utils/methods/removedReference"
import { getArea, getDepartments, getDivisions, getZones } from "../../../../../../../../../utils/methods/geServiceWithItemsFormat"
import { Roles, Status } from "../../../../../../../../../utils/enums"
import { loogbookServiceFetch } from "../../../../../../../../../utils/constants/callService"
import { formatTypeActivityResponse } from "../../../../../../../../../service/logbook/format/activity"
import { Typography } from "@mui/material"
import { ClipOpenEvidence } from "../components/clipOpenEvidence"
import { EvidenceDataHook } from "../../../../../../../../../hooks/evidences/typyng"
import { UploadEvidenceData } from "../../../../../../../../../components/uploadEvidence/hooks"
import { GetEvidencePayload } from "../../../detailHeader/types"
import { FormatEvidenceData } from "../../../../../../../../../components/uploadEvidence/contants"
import { EvidencesTypeValueEnum } from "../../../../../../../../../utils/enums/evidences"




const useInput = () => {

  const [allDepartments, setAllDepartments] = useState<Item[]>([])

  const formatFilter = {
    area: 'areas_ids',
    department: 'departments_ids',
  }

  const formatFilterUnity = {
    division: 'division_ids',
    zone: 'zone_ids'
  }


  const [inputFilter, setInputFilter] = useState<{ [x: string]: InputModel }>({
    search: {
      label: 'general.searchUsers',
      translate: true,
      name: 'search',
      value: null,
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 4,
      },
    },
    area: {
      label: 'general.tags.area',
      translate: true,
      name: 'area',
      type: 'filter-select',
      items: [],
      value: null,
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 4,
      },
    },
    department: {
      label: 'general.tags.department',
      translate: true,
      name: 'department',
      type: 'filter-select',
      items: [],
      value: null,
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 4,
      },
    },
  })

  const [inputFilterUnity, setInputFilterUnity] = useState<{ [x: string]: InputModel }>({
    search: {
      label: 'general.tags.name',
      translate: true,
      name: 'search',
      value: null,
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 4,
      },
    },
    division: {
      label: 'general.tags.division',
      translate: true,
      name: 'division',
      type: 'filter-select',
      items: [],
      value: null,
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 4,
      },
    },
    zone: {
      label: 'general.tags.zone',
      translate: true,
      name: 'zone',
      type: 'filter-select',
      items: [],
      value: null,
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 4,
      },
    },
    onlyHierarchy: {
      label: 'loogbook.inputs.assignedUnitsOnly',
      translate: true,
      name: 'onlyHierarchy',
      type: 'switch',
      items: [],
      notAllowedRoles: [Roles.ADMIN],
      value: null,
      size: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
      },
    },
  })

  const [inputActivity, setInputActivity] = useState<{ [x: string]: InputModel }>({
    title: {
      label: 'general.tags.title',
      translate: true,
      name: 'title',
      value: null,
      validate: {
        min: true,
        minLenght: 3,
        required: true
      },
      rest: {
        min: 3,
        type: 'alphaNumeric',
      },
    },
  })

  const [inputSecondActivity, setInputSecondActivity] = useState<{ [x: string]: InputModel }>({
    typeOfActivity: {
      label: 'general.tags.activityType',
      translate: true,
      name: 'typeOfActivity',
      type: 'select-search',
      items: [],
      value: null,
      size: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
      },
    }
  })

  const [inputLastActivity, setInputLastActivity] = useState<{ [x: string]: InputModel }>({
    observation: {
      label: 'general.observation',
      translate: true,
      name: 'observation',
      type: 'textArea',
      rest: {
        rows: 4,
        maxRows: 4
      },
      value: null,

    },
  })


  const [inputDestination, setInputDestination] = useState<{ [x: string]: InputModel }>({
    title: {
      label: 'loogbook.inputs.destinationName',
      translate: true,
      name: 'title',
      value: null,
      validate: {
        required: true,
        min: true,
        minLenght: 3
      },
      rest: {
        min: 3,
        type: 'alphaNumeric',
      },
      customeErrors: {
        required: 'loogbook.errors.nameDestination',
      },
    },
  })

  const openField: InputModel = {
    label: "loogbook.inputs.activityTypeText",
    translate: true,
    name: "open",
    validate: {
      required: true,
      min: true,
      minLenght: 3
    },
    type: 'textArea',
    rest: {
      rows: 3,
      maxRows: 3,
      min: 3,
      inputProps: {
        maxLength: 250,
      },
    },
    value: null,
    size: {
      lg: 12,
      md: 12,
      sm: 12,
      xl: 12,
      xs: 12,
    },
    customeErrors: {
      required: 'loogbook.errors.activityTypeText',
    },
  };


  const externalValidation: FilterProps['externalValidation'] = ({ name, body, setFilterData }) => {
    let copyBody: Record<string, any> = removeAllReference(body)

    if (name === 'area') {
      const { area, department } = copyBody
      const newDepartments = department?.filter((e: any) => area.find((e2: any) => e2.value == e.areaId))
      let arrayChilds: any[] = []

      area?.forEach((e: any) => {
        const id = e.value
        const childs = allDepartments.filter((child) => child.areaId == id)
        arrayChilds.push(...childs)
      })

      setFilterData((prev) => ({
        ...prev,
        department: newDepartments,
      }))

      setInputFilter(prev => ({ ...prev, department: { ...prev.department, items: arrayChilds } }))
      copyBody = {
        ...copyBody,
        department: newDepartments,
      }
    }

    return copyBody
  }

  const getAllDepartments = async () => {
    const items = await getDepartments()
    setAllDepartments(items)
  }

  const getAllAreas = async () => {
    const items = await getArea()
    setInputFilter(prev => ({ ...prev, area: { ...prev.area, items: items } }))
  }

  const getTypeOfActivity = async () => {
    const response = await loogbookServiceFetch.getTypeOfActivity()
    const { items } = formatTypeActivityResponse({ response })
    setInputSecondActivity(prev => ({ ...prev, typeOfActivity: { ...prev.typeOfActivity, items: items } }))
  }

  const getDivisionsService = async () => {
    const division = await getDivisions()

    setInputFilterUnity((prev) => ({ ...prev, division: { ...prev.division, items: division.items } }))
  }

  const getZonesService = async () => {
    const { fatherZones } = await getZones()

    setInputFilterUnity((prev) => ({ ...prev, zone: { ...prev.zone, items: fatherZones } }))
  }

  const getData = () => {
    getAllAreas()
    getAllDepartments()
    getDivisionsService()
    getZonesService()
    getTypeOfActivity()
  }

  useEffect(() => {
    getData()
  }, [])

  const filter = useFilter({
    formatFilter,
    externalValidation: externalValidation,
    defaultPagination: { pageSize: 500 }
  })

  const filterUnity = useFilter({
    formatFilter: formatFilterUnity
  })


  return { filter, openField, setInputLastActivity, inputFilter, inputActivity, inputLastActivity, inputFilterUnity, formatFilter, filterUnity, formatFilterUnity, inputDestination, inputSecondActivity }
}

export { useInput }